import React from 'react';
import PropTypes from 'prop-types';
import Conversation from '../../chat/chat-components/Conversation';
import config from "../../../../../config";

export const generalStyles = {
    wrapper: {
        position: 'relative',
        height: '100%',
        display: 'flex',
        gap: '20px'
    },
    header: {
        zIndex: '10',
        top: 0,
        height: '50px',
        width: '100%',
        backgroundColor: 'white',
        border: 'none',
        textAlign: 'left',
        cursor: 'pointer',
        position: 'absolute',
    },
    modalStyles: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '50000',
        },
        content: {
            zIndex: '2000',
            height: '100%',
            position: 'unset',
            border: 'none',
            borderRadius: 'none',
            backgroundColor: '#F2F5FC',
            padding: 'none',
            marginLeft: 'auto',
            marginRight: '0',
            width: 'fit-content'
        },
    }
};

const ConversationHistory = ({
                                 conversation, loadOlderMessages, user, tariff, company
                             }) => (
        <div style={generalStyles.wrapper}>
            <div>
                <Conversation conversation={conversation}
                              loadOlderMessages={loadOlderMessages}
                              user={user}
                              readOnly
                              showSideBar={false}
                              hasBackButton={false}
                              tariff={tariff}
                              company={company}
                />
            </div>
        </div>
    )
;

ConversationHistory.propTypes = {
    conversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    loadOlderMessages: PropTypes.func.isRequired,
    closeWindow: PropTypes.func.isRequired,
};

export default ConversationHistory;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/ConversationHistory.jsx